module.exports = __webpack_public_path__ + "images/thumb-down.66afbe46f77148c88858.png";